import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE5Items = getItem('FE5', 'FE5', <FolderOutlined />, [
  getItem('Army Data - Ch 23 Koruta', 'FE5/ArmyDataCh23Koruta'),
  getItem('Army Data - Ch1 Manster1', 'FE5/ArmyDataCh1Manster1'),
  getItem('Army Data - Ch1 Manster2', 'FE5/ArmyDataCh1Manster2'),
  getItem('Army Data - Ch1 Manster3', 'FE5/ArmyDataCh1Manster3'),
  getItem('Army Data - Ch1 Mareeta/Nanna', 'FE5/Nanna'),
  getItem('Army Data - Ch1 Weissman', 'FE5/ArmyDataCh1Weissman'),
  getItem('Army Data - Ch10 Fred/Oruen', 'FE5/Oruen'),
  getItem('Army Data - Ch10 Freege1', 'FE5/ArmyDataCh10Freege1'),
  getItem('Army Data - Ch10 Freege2', 'FE5/ArmyDataCh10Freege2'),
  getItem('Army Data - Ch10 Freege3', 'FE5/ArmyDataCh10Freege3'),
  getItem('Army Data - Ch10 Ralgo', 'FE5/ArmyDataCh10Ralgo'),
  getItem('Army Data - Ch11 Fred', 'FE5/ArmyDataCh11Fred'),
  getItem('Army Data - Ch11 Freege1', 'FE5/ArmyDataCh11Freege1'),
  getItem('Army Data - Ch11 Freege2', 'FE5/ArmyDataCh11Freege2'),
  getItem('Army Data - Ch11 Oruen', 'FE5/ArmyDataCh11Oruen'),
  getItem('Army Data - Ch11x Fred', 'FE5/ArmyDataCh11xFred'),
  getItem('Army Data - Ch11x Freege1', 'FE5/ArmyDataCh11xFreege1'),
  getItem('Army Data - Ch11x Freege2', 'FE5/ArmyDataCh11xFreege2'),
  getItem('Army Data - Ch11x Freege3', 'FE5/ArmyDataCh11xFreege3'),
  getItem('Army Data - Ch11x Freege4', 'FE5/ArmyDataCh11xFreege4'),
  getItem('Army Data - Ch11x NPCs', 'FE5/ArmyDataCh11xNPCs'),
  getItem('Army Data - Ch11x Oruen', 'FE5/ArmyDataCh11xOruen'),
  getItem('Army Data - Ch12 Mareeta', 'FE5/ArmyDataCh12Mareeta'),
  getItem('Army Data - Ch12 Seiram', 'FE5/ArmyDataCh12Seiram'),
  getItem('Army Data - Ch12x BowFighter', 'FE5/ArmyDataCh12xBowFighter'),
  getItem('Army Data - Ch12x Trewd/Pahn/Tina', 'FE5/Tina'),
  getItem('Army Data - Ch13 Freege1', 'FE5/ArmyDataCh13Freege1'),
  getItem('Army Data - Ch13 Freege2', 'FE5/ArmyDataCh13Freege2'),
  getItem('Army Data - Ch13 Glade', 'FE5/ArmyDataCh13Glade'),
  getItem('Army Data - Ch13 Lenster', 'FE5/ArmyDataCh13Lenster'),
  getItem('Army Data - Ch13 Paluce', 'FE5/ArmyDataCh13Paluce'),
  getItem('Army Data - Ch14 Aightman', 'FE5/ArmyDataCh14Aightman'),
  getItem('Army Data - Ch14 Arione/Torborant/Homeros/Dean/Eda', 'FE5/Eda'),
  getItem('Army Data - Ch14 Freege1', 'FE5/ArmyDataCh14Freege1'),
  getItem('Army Data - Ch14 Freege2', 'FE5/ArmyDataCh14Freege2'),
  getItem('Army Data - Ch14 Freege3', 'FE5/ArmyDataCh14Freege3'),
  getItem('Army Data - Ch14 Linonan', 'FE5/ArmyDataCh14Linonan'),
  getItem('Army Data - Ch14 Makroi', 'FE5/ArmyDataCh14Makroi'),
  getItem('Army Data - Ch14 Roputo', 'FE5/ArmyDataCh14Roputo'),
  getItem('Army Data - Ch14x Sleuf/Linonan', 'FE5/Linonan'),
  getItem('Army Data - Ch15 Amalda/Ralf', 'FE5/Ralf'),
  getItem('Army Data - Ch15 Bandit1', 'FE5/ArmyDataCh15Bandit1'),
  getItem('Army Data - Ch15 Bandit2', 'FE5/ArmyDataCh15Bandit2'),
  getItem('Army Data - Ch15 Bandit3', 'FE5/ArmyDataCh15Bandit3'),
  getItem('Army Data - Ch15 Bandit4', 'FE5/ArmyDataCh15Bandit4'),
  getItem('Army Data - Ch15 Shanam', 'FE5/ArmyDataCh15Shanam'),
  getItem('Army Data - Ch15 Thief', 'FE5/ArmyDataCh15Thief'),
  getItem('Army Data - Ch15 Zail', 'FE5/ArmyDataCh15Zail'),
  getItem('Army Data - Ch16A Bluke', 'FE5/ArmyDataCh16ABluke'),
  getItem('Army Data - Ch16A Conomore', 'FE5/ArmyDataCh16AConomore'),
  getItem('Army Data - Ch16A Nikolaf', 'FE5/ArmyDataCh16ANikolaf'),
  getItem('Army Data - Ch16A Silesia', 'FE5/ArmyDataCh16ASilesia'),
  getItem('Army Data - Ch16A Sleuf', 'FE5/ArmyDataCh16ASleuf'),
  getItem('Army Data - Ch16B Miranda/Sara/Shanam', 'FE5/Shanam'),
  getItem('Army Data - Ch16B Reincock', 'FE5/ArmyDataCh16BReincock'),
  getItem('Army Data - Ch17A Cyas/Sara/Reinhardt/Ishtar', 'FE5/Ishtar'),
  getItem('Army Data - Ch17A Myura', 'FE5/ArmyDataCh17AMyura'),
  getItem('Army Data - Ch17A Nokolaf/Misha', 'FE5/Misha'),
  getItem('Army Data - Ch17B Amalda', 'FE5/ArmyDataCh17BAmalda'),
  getItem('Army Data - Ch17B Freege', 'FE5/ArmyDataCh17BFreege'),
  getItem('Army Data - Ch17B Palman', 'FE5/ArmyDataCh17BPalman'),
  getItem('Army Data - Ch17B Resistance', 'FE5/ArmyDataCh17BResistance'),
  getItem('Army Data - Ch18 Freege1', 'FE5/ArmyDataCh18Freege1'),
  getItem('Army Data - Ch18 Freege2', 'FE5/ArmyDataCh18Freege2'),
  getItem('Army Data - Ch18 Gustav/Xavier', 'FE5/Xavier'),
  getItem('Army Data - Ch18 Roputo', 'FE5/ArmyDataCh18Roputo'),
  getItem('Army Data - Ch19 Amalda/Conomore', 'FE5/Conomore'),
  getItem('Army Data - Ch19 Bandit', 'FE5/ArmyDataCh19Bandit'),
  getItem('Army Data - Ch19 Freege1', 'FE5/ArmyDataCh19Freege1'),
  getItem('Army Data - Ch19 Freege2', 'FE5/ArmyDataCh19Freege2'),
  getItem('Army Data - Ch19 Ishtar/Leidrick', 'FE5/Leidrick'),
  getItem('Army Data - Ch19 Leidrick', 'FE5/ArmyDataCh19Leidrick'),
  getItem('Army Data - Ch19 NPCs', 'FE5/ArmyDataCh19NPCs'),
  getItem('Army Data - Ch19 Thief', 'FE5/ArmyDataCh19Thief'),
  getItem('Army Data - Ch19 Wolf', 'FE5/ArmyDataCh19Wolf'),
  getItem('Army Data - Ch2 Bugs', 'FE5/ArmyDataCh2Bugs'),
  getItem('Army Data - Ch2 Rifis Gang1', 'FE5/ArmyDataCh2RifisGang1'),
  getItem('Army Data - Ch2 Rifis Gang2', 'FE5/ArmyDataCh2RifisGang2'),
  getItem('Army Data - Ch2 Rifis Gang3', 'FE5/ArmyDataCh2RifisGang3'),
  getItem('Army Data - Ch2 Rifis Gang4', 'FE5/ArmyDataCh2RifisGang4'),
  getItem('Army Data - Ch2 Rifis Gang5', 'FE5/ArmyDataCh2RifisGang5'),
  getItem('Army Data - Ch2 Rifis Gang6', 'FE5/ArmyDataCh2RifisGang6'),
  getItem('Army Data - Ch2 Rifis Gang7', 'FE5/ArmyDataCh2RifisGang7'),
  getItem('Army Data - Ch2 Rifis Gang8', 'FE5/ArmyDataCh2RifisGang8'),
  getItem('Army Data - Ch2 Ronan', 'FE5/ArmyDataCh2Ronan'),
  getItem('Army Data - Ch20 Barrat', 'FE5/ArmyDataCh20Barrat'),
  getItem('Army Data - Ch20 Freege1', 'FE5/ArmyDataCh20Freege1'),
  getItem('Army Data - Ch20 Freege2', 'FE5/ArmyDataCh20Freege2'),
  getItem('Army Data - Ch20 Freege3', 'FE5/ArmyDataCh20Freege3'),
  getItem('Army Data - Ch20 Freege4', 'FE5/ArmyDataCh20Freege4'),
  getItem('Army Data - Ch20 Freege5', 'FE5/ArmyDataCh20Freege5'),
  getItem('Army Data - Ch20 Freege6', 'FE5/ArmyDataCh20Freege6'),
  getItem('Army Data - Ch20 Freege7', 'FE5/ArmyDataCh20Freege7'),
  getItem('Army Data - Ch20 Freege8', 'FE5/ArmyDataCh20Freege8'),
  getItem('Army Data - Ch20 Reinhardt', 'FE5/ArmyDataCh20Reinhardt'),
  getItem('Army Data - Ch21 Delmud', 'FE5/ArmyDataCh21Delmud'),
  getItem('Army Data - Ch21 Freege', 'FE5/ArmyDataCh21Freege'),
  getItem('Army Data - Ch21 Freege2', 'FE5/ArmyDataCh21Freege2'),
  getItem('Army Data - Ch21 Phlaus', 'FE5/ArmyDataCh21Phlaus'),
  getItem('Army Data - Ch21 Roputo', 'FE5/ArmyDataCh21Roputo'),
  getItem('Army Data - Ch21 Semitol', 'FE5/ArmyDataCh21Semitol'),
  getItem('Army Data - Ch21x Freege', 'FE5/ArmyDataCh21xFreege'),
  getItem('Army Data - Ch21x Freege2', 'FE5/ArmyDataCh21xFreege2'),
  getItem('Army Data - Ch21x Freege3', 'FE5/ArmyDataCh21xFreege3'),
  getItem('Army Data - Ch21x Roputo', 'FE5/ArmyDataCh21xRoputo'),
  getItem('Army Data - Ch21x Roputo2', 'FE5/ArmyDataCh21xRoputo2'),
  getItem('Army Data - Ch21x Zaom', 'FE5/ArmyDataCh21xZaom'),
  getItem('Army Data - Ch22 Cyas/Koen', 'FE5/Koen'),
  getItem('Army Data - Ch22 Freege', 'FE5/ArmyDataCh22Freege'),
  getItem('Army Data - Ch22 Freege2', 'FE5/ArmyDataCh22Freege2'),
  getItem('Army Data - Ch23 Alphane/Ferdan', 'FE5/Ferdan'),
  getItem('Army Data - Ch23 Cyas/Sety', 'FE5/Sety'),
  getItem('Army Data - Ch23 Manster', 'FE5/ArmyDataCh23Manster'),
  getItem('Army Data - Ch23 NPCs', 'FE5/ArmyDataCh23NPCs'),
  getItem('Army Data - Ch23 Thief', 'FE5/ArmyDataCh23Thief'),
  getItem('Army Data - Ch24 Galzus/Beldo', 'FE5/Beldo'),
  getItem('Army Data - Ch24 Leidrick', 'FE5/ArmyDataCh24Leidrick'),
  getItem('Army Data - Ch24 Manster', 'FE5/ArmyDataCh24Manster'),
  getItem('Army Data - Ch24 Roputo', 'FE5/ArmyDataCh24Roputo'),
  getItem('Army Data - Ch24 Roputo2', 'FE5/ArmyDataCh24Roputo2'),
  getItem('Army Data - Ch24x Lopto', 'FE5/ArmyDataCh24xLopto'),
  getItem('Army Data - Ch24x Roputo', 'FE5/ArmyDataCh24xRoputo'),
  getItem('Army Data - Ch24x Sniper', 'FE5/ArmyDataCh24xSniper'),
  getItem('Army Data - Ch2x Rifis Gang1', 'FE5/ArmyDataCh2xRifisGang1'),
  getItem('Army Data - Ch2x Rifis Gang2', 'FE5/ArmyDataCh2xRifisGang2'),
  getItem('Army Data - Ch2x Rifis Gang3', 'FE5/ArmyDataCh2xRifisGang3'),
  getItem('Army Data - Ch2x Rifis Gang4', 'FE5/ArmyDataCh2xRifisGang4'),
  getItem('Army Data - Ch2x Rifis Gang5', 'FE5/ArmyDataCh2xRifisGang5'),
  getItem('Army Data - Ch2x Rifis Gang6', 'FE5/ArmyDataCh2xRifisGang6'),
  getItem('Army Data - Ch2x Rifis/Shiva', 'FE5/Shiva'),
  getItem('Army Data - Ch2x Saphy', 'FE5/ArmyDataCh2xSaphy'),
  getItem('Army Data - Ch3 Manster1', 'FE5/ArmyDataCh3Manster1'),
  getItem('Army Data - Ch3 Manster2', 'FE5/ArmyDataCh3Manster2'),
  getItem('Army Data - Ch3 Manster3', 'FE5/ArmyDataCh3Manster3'),
  getItem('Army Data - Ch3 Manster4', 'FE5/ArmyDataCh3Manster4'),
  getItem('Army Data - Ch3 Manster5', 'FE5/ArmyDataCh3Manster5'),
  getItem('Army Data - Ch3 Manster6', 'FE5/ArmyDataCh3Manster6'),
  getItem('Army Data - Ch3 NPCs', 'FE5/ArmyDataCh3NPCs'),
  getItem('Army Data - Ch3 Thracia', 'FE5/ArmyDataCh3Thracia'),
  getItem('Army Data - Ch4 Bandit', 'FE5/ArmyDataCh4Bandit'),
  getItem('Army Data - Ch4 Dalshein', 'FE5/ArmyDataCh4Dalshein'),
  getItem('Army Data - Ch4 Felgus/Karin', 'FE5/Karin'),
  getItem('Army Data - Ch4 Ishtar/Yurius/Beldo/Manfroy', 'FE5/Manfroy'),
  getItem('Army Data - Ch4 Manster1', 'FE5/ArmyDataCh4Manster1'),
  getItem('Army Data - Ch4 Manster2', 'FE5/ArmyDataCh4Manster2'),
  getItem('Army Data - Ch4 Manster3', 'FE5/ArmyDataCh4Manster3'),
  getItem('Army Data - Ch4 Manster4', 'FE5/ArmyDataCh4Manster4'),
  getItem('Army Data - Ch4 NPCs1', 'FE5/ArmyDataCh4NPCs1'),
  getItem('Army Data - Ch4 NPCs2', 'FE5/ArmyDataCh4NPCs2'),
  getItem('Army Data - Ch4 Sety4G/Asvel/Brighton/Machyua/Lara', 'FE5/Lara'),
  getItem('Army Data - Ch4x Asvel/Sety4G', 'FE5/Sety4G'),
  getItem('Army Data - Ch4x Manster1', 'FE5/ArmyDataCh4xManster1'),
  getItem('Army Data - Ch4x Manster2', 'FE5/ArmyDataCh4xManster2'),
  getItem('Army Data - Ch4x Manster3', 'FE5/ArmyDataCh4xManster3'),
  getItem('Army Data - Ch4x NPCs', 'FE5/ArmyDataCh4xNPCs'),
  getItem('Army Data - Ch5 August', 'FE5/ArmyDataCh5August'),
  getItem('Army Data - Ch5 Manster1', 'FE5/ArmyDataCh5Manster1'),
  getItem('Army Data - Ch5 Manster2', 'FE5/ArmyDataCh5Manster2'),
  getItem('Army Data - Ch5 Manster3', 'FE5/ArmyDataCh5Manster3'),
  getItem('Army Data - Ch5 Mareeta/Galzus', 'FE5/Galzus'),
  getItem('Army Data - Ch5 Nanna', 'FE5/ArmyDataCh5Nanna'),
  getItem('Army Data - Ch6 Galzus/Mareeta/Cyas', 'FE5/Cyas'),
  getItem('Army Data - Ch6 Hicks', 'FE5/ArmyDataCh6Hicks'),
  getItem('Army Data - Ch6 Manster1', 'FE5/ArmyDataCh6Manster1'),
  getItem('Army Data - Ch6 Manster2', 'FE5/ArmyDataCh6Manster2'),
  getItem('Army Data - Ch6 Manster3', 'FE5/ArmyDataCh6Manster3'),
  getItem('Army Data - Ch6 Manster4', 'FE5/ArmyDataCh6Manster4'),
  getItem('Army Data - Ch6 Manster5', 'FE5/ArmyDataCh6Manster5'),
  getItem('Army Data - Ch6 Sety4G', 'FE5/ArmyDataCh6Sety4G'),
  getItem('Army Data - Ch7 Bandit', 'FE5/ArmyDataCh7Bandit'),
  getItem('Army Data - Ch7 Hannibal', 'FE5/ArmyDataCh7Hannibal'),
  getItem('Army Data - Ch7 Izenau', 'FE5/ArmyDataCh7Izenau'),
  getItem('Army Data - Ch7 Leidrick', 'FE5/ArmyDataCh7Leidrick'),
  getItem('Army Data - Ch7 Manster1', 'FE5/ArmyDataCh7Manster1'),
  getItem('Army Data - Ch7 Manster2', 'FE5/ArmyDataCh7Manster2'),
  getItem('Army Data - Ch7 Manster3', 'FE5/ArmyDataCh7Manster3'),
  getItem('Army Data - Ch7 Shiva', 'FE5/ArmyDataCh7Shiva'),
  getItem('Army Data - Ch7 Thracia', 'FE5/ArmyDataCh7Thracia'),
  getItem('Army Data - Ch8 Bandit1', 'FE5/ArmyDataCh8Bandit1'),
  getItem('Army Data - Ch8 Bandit2', 'FE5/ArmyDataCh8Bandit2'),
  getItem('Army Data - Ch8 Carrion', 'FE5/ArmyDataCh8Carrion'),
  getItem('Army Data - Ch8x Gomez', 'FE5/ArmyDataCh8xGomez'),
  getItem('Army Data - Ch9 Alba/Roberto', 'FE5/Roberto'),
  getItem('Army Data - Ch9 Altenna', 'FE5/ArmyDataCh9Altenna'),
  getItem('Army Data - Ch9 Altenna/Torabant', 'FE5/Torabant'),
  getItem('Army Data - Ch9 Mallock', 'FE5/ArmyDataCh9Mallock'),
  getItem('Army Data - Ch9 Selfina/Kein', 'FE5/Kein'),
  getItem('Army Data - Ch9 Thracia1', 'FE5/ArmyDataCh9Thracia1'),
  getItem('Army Data - Ch9 Thracia2', 'FE5/ArmyDataCh9Thracia2'),
  getItem('Army Data - ChFinal Beldo', 'FE5/ArmyDataChFinalBeldo'),
  getItem('Army Data - ChFinal DarkSoldiers', 'FE5/ArmyDataChFinalDarkSoldiers'),
  getItem('Ch1 Leaf, Finn, Eyvel, Othin, Halvan', 'FE5/Ch1LeafFinnEyvelOthinHalvan'),
  getItem('Ch1 Marty, Dagudar, Tanya', 'FE5/Ch1MartyDagudarTanya'),
  getItem('FE5 Arena Class Editor 1', 'FE5/ArenaClassEditor1'),
  getItem('FE5 Arena Class Editor 2', 'FE5/ArenaClassEditor2'),
  getItem('FE5 Arena Class Editor 3', 'FE5/ArenaClassEditor3'),
  getItem('FE5 Arena Weapon Editor', 'FE5/ArenaWeaponEditor'),
  getItem('FE5 Battle Animation Editor', 'FE5/BattleAnimationEditor'),
  getItem('FE5 Battle Sprite Editor', 'FE5/BattleSpriteEditor'),
  getItem('FE5 Boss Quote Editor', 'FE5/BossQuoteEditor'),
  getItem('FE5 Character Editor', 'FE5/CharacterEditor'),
  getItem('FE5 Class Editor', 'FE5/ClassEditor'),
  getItem('FE5 Custom Effectiveness Editor', 'FE5/CustomEffectivenessEditor'),
  getItem('FE5 Custom Stat Bonuses Editor', 'FE5/CustomStatBonusesEditor'),
  getItem('FE5 Custom Weapon Lock Editor', 'FE5/CustomWeaponLockEditor'),
  getItem('FE5 Death Quote Editor', 'FE5/DeathQuoteEditor'),
  getItem('FE5 Escape Quote Editor', 'FE5/EscapeQuoteEditor'),
  getItem('FE5 Item Editor', 'FE5/ItemEditor'),
  getItem('FE5 Magic Animation Editor', 'FE5/MagicAnimationEditor'),
  getItem('FE5 Mount/Dismount Editor', 'FE5/DismountEditor'),
  getItem('FE5 Portrait to Map Relation Editor', 'FE5/PortraittoMapRelationEditor'),
  getItem('FE5 Promotion Editor', 'FE5/PromotionEditor'),
  getItem('FE5 Scrolls Editor', 'FE5/ScrollsEditor'),
  getItem('FE5 Shield Association Editor', 'FE5/ShieldAssociationEditor'),
  getItem('FE5 Supports Editor', 'FE5/SupportsEditor'),
  getItem('FE5 Terrain Movement Cost Editor', 'FE5/TerrainMovementCostEditor'),
  getItem('FE5 Weapon Triangle Bonus Editor', 'FE5/WeaponTriangleBonusEditor'),
  getItem('FE5 Weapon Triangle Editor', 'FE5/WeaponTriangleEditor'),
  getItem('Leaf, Finn, Eyvel, Othin, Halvan', 'FE5/LeafFinnEyvelOthinHalvan'),
  getItem('Marty, Dagudar, Tanya', 'FE5/MartyDagudarTanya'),
]);

export default FE5Items;
